import React, { useEffect, useState } from "react";
import { sendToAndroid } from "../services/androidBridge";
import { useParams } from 'react-router-dom';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';

const UtilityTransfer = () => {
    const { fields } = useParams();
    
   
    const [selectedAccount, setSelectedAccount] = useState(null);
    const [accountList, setAccountList] = useState([]);
    const [inputValues, setInputValues] = useState("");
    const [, setJwt] = useState('');
    const [confirmMessage] = useState('notLoaded');
    const [successMessage] = useState('notLoaded');
    const jsonObject = JSON.parse(fields);

    const handleInputChange = (key, value) => {
        setInputValues((prevValues) => ({
          ...prevValues,
          [key]: value,
        }));
      };

    useEffect(() => {
        sendDataToAndroid("first");
        window.receiveDataFromAndroid = (data) => {
          var dataString = JSON.stringify(data);
          var obj = JSON.parse(dataString);
    
          if (JSON.parse(obj.request).name === "accountList") {
           
            if (
              obj.response !== undefined &&
              JSON.parse(obj.response).data !== undefined
            ) {
              
              let uniqueAccountList = [];

              JSON.parse(JSON.parse(obj.response).data).forEach((account) => {
               
                uniqueAccountList = [
                  ...uniqueAccountList,
                  { label: account.accounts, value: account.accounts },
                ];
               
                setAccountList([...uniqueAccountList]);
              });
            }
          } else if (JSON.parse(obj.request).name === "confirmResponse") {
           
    

          } else if (JSON.parse(obj.request).name === "jwt") {
            
            setJwt(JSON.parse(obj.response).data);
          }
        };
      }, []);

      const sendDataToAndroid = (name) => {
        var transferData = {
          transferData: [],
        };
        if (name === "return") {
          transferData = {
            transferData: [
              {
                type: "return",
                request: { name: "graphData" },
                response: {},
                name: "",
              },
            ],
          };
        } else if (name === "first") {
          transferData = {
            transferData: [
              {
                type: "first",
                request: { name: "first" },
                response: {},
                name: "",
              },
            ],
          };
        }
         else if (name === "confirm") {
          transferData = {
            transferData: [
              {
                type: "confirm",
                request: { name: "confirm" },
                response: { data: confirmMessage },
                name: "",
              },
            ],
          };
        } else if (name === "success") {
          transferData = {
            transferData: [
              {
                type: "success",
                request: { name: "success" },
                response: { data: successMessage },
                name: "",
              },
            ],
          };
        }
        console.log(JSON.stringify(transferData));
        sendToAndroid(transferData);
      };

  return (

    <div className="service-screen w-full max-w-md mx-auto p-4">
      <div className="mb-4 font-light">
        <label className="block text-gray-700 text-sm font-bold mb-2 font-medium" htmlFor="account">
          Your Account
        </label>

        <Dropdown
          id="account"
          value={selectedAccount}
          s
          options={accountList}
          onChange={e => setSelectedAccount(e.value)}
          placeholder="select"
          optionLabel="value"
          className="w-full md:w-14rem border-2 p-2 border-slate-600 rounded-md "
          panelClassName="custom-dropdown-panel"
        />
      </div>
      <ul>
     { Object.entries(jsonObject).map(([key, value]) => (
          <li key={key} >
                  <div className="mb-4">
        <label className="block text-gray-700 text-sm font-bold mb-2 font-medium" htmlFor="amount">
        {value}
        </label>
        <InputText
          id="amount"
          value={inputValues[key] || ''}
          onChange={(e) => handleInputChange(key, e.target.value)}
          className="p-inputtext-sm w-full  border-2 border-slate-600 rounded-md p-2 "
        />
      </div>
     
          </li>
        ))}
      </ul>
      <Button
        label="Confirm"
        severity="info"
        icon="pi pi-arrow-right "
        onClick={e => console.log("clicked")}
        className="p-button-success bg-sky-600 w-full p-2 rounded-md hover:bg-blue-800"
      />
      
        
    </div>
  )
}

export default UtilityTransfer
